import React from 'react';
import RoboneoModal from '$/components/Modal';
import Button from '$/components/base/Button';
import { useLanguageStore } from '$/store/languageStore';
import { VIP_MODAL_CHILD_Z_INDEX } from '../constants';
import styles from './index.module.scss';

interface ContactSalesModalProps {
  open: boolean;
  description?: React.ReactNode;
  onOpenChange?: (open: boolean) => void;
}

/**
 * 移除 Smartcat/Figma 导出的富文本标签，销售联系弹窗只展示纯文本内容。
 */
function stripHtmlTags(template: string) {
  return template.replace(/<[^>]+>/g, '');
}

/**
 * 联系销售弹窗，用于展示销售联系方式。
 */
function ContactSalesModal({ open, description, onOpenChange }: ContactSalesModalProps) {
  const languageStore = useLanguageStore((state) => state.languageStore);
  const contactSalesDescription = stripHtmlTags(
    languageStore.smartcatTranslationText((v) => v.contact_sales_4000093360_roboneo_com),
  );

  /**
   * 关闭弹窗。
   */
  function handleClose() {
    onOpenChange?.(false);
  }

  return (
    <RoboneoModal
      wrapClassName={styles.modalWrapper}
      bodyClassName={styles.modalBody}
      open={open}
      onCancel={handleClose}
      closable
      width={480}
      zIndex={VIP_MODAL_CHILD_Z_INDEX}
    >
      <div className={styles.header} />
      <div className={styles.desc}>
        {description || contactSalesDescription}
      </div>
      <div className={styles.footer}>
        <Button
          type="plain"
          className={styles.confirmButton}
          onClick={handleClose}
        >
          {languageStore.smartcatTranslationText((v) => v.roboneo_web_ot)}
        </Button>
      </div>
    </RoboneoModal>
  );
}

export default ContactSalesModal;
